// utils/network.ts
export const checkAndSwitchNetwork = async (
  provider: any, // Ethereum provider
  targetChainId = "0x89"
): Promise<boolean> => {
  try {
    const currentChainId = await provider.request({ method: "eth_chainId" });
    console.log("Current Chain ID:", currentChainId);

    if (currentChainId !== targetChainId) {
      console.log(`Switching to chain ${targetChainId}...`);

      await provider.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: targetChainId }],
      });

      const newChainId = await provider.request({ method: "eth_chainId" });
      console.log("New Chain ID after switch:", newChainId);

      return newChainId === targetChainId;
    }

    return true;
  } catch (error) {
    console.error("Error during network check/switch:", error);
    return false;
  }
};
